// Code generated by OpenAPI Generator (https://openapi-generator.tech), manual changes will be lost - read more on https://github.com/algolia/api-clients-automation. DO NOT EDIT.

export type AbtestingV3Client = ReturnType<typeof createAbtestingV3Client>;

import { gzipSync } from 'node:zlib';

import { createMemoryCache, createNullCache, createNullLogger } from '@algolia/client-common';
import { createHttpRequester } from '@algolia/requester-node-http';

import type { ClientOptions } from '@algolia/client-common';

import { createAbtestingV3Client } from '../src/abtestingV3Client';

import type { Region } from '../src/abtestingV3Client';
import { REGIONS } from '../src/abtestingV3Client';

export type { Region, RegionOptions } from '../src/abtestingV3Client';

export { apiClientVersion } from '../src/abtestingV3Client';

export * from '../model';

export function abtestingV3Client(
  appId: string,
  apiKey: string,
  region?: Region | undefined,
  options?: ClientOptions | undefined,
): AbtestingV3Client {
  if (!appId || typeof appId !== 'string') {
    throw new Error('`appId` is missing.');
  }

  if (!apiKey || typeof apiKey !== 'string') {
    throw new Error('`apiKey` is missing.');
  }

  if (region && (typeof region !== 'string' || !REGIONS.includes(region))) {
    throw new Error(`\`region\` must be one of the following: ${REGIONS.join(', ')}`);
  }

  return {
    ...createAbtestingV3Client({
      appId,
      apiKey,
      region,
      timeouts: {
        connect: 2000,
        read: 5000,
        write: 30000,
      },
      logger: createNullLogger(),
      requester: createHttpRequester(),
      algoliaAgents: [{ segment: 'Node.js', version: process.versions.node }],
      responsesCache: createNullCache(),
      requestsCache: createNullCache(),
      hostsCache: createMemoryCache(),
      compress: async (data: string): Promise<Uint8Array> => gzipSync(Buffer.from(data)),
      ...options,
    }),
  };
}
